import { Link, useParams } from 'react-router-dom'
import { Card, Button } from '@/components/ui'
import { Header, Footer } from '@/components/layout'

export default function Cancelled() {
  const { shortCode } = useParams<{ shortCode: string }>()

  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <Header />

      <main className="flex-1 w-full max-w-2xl mx-auto px-4 py-8 md:py-12">
        <div className="fade-in">
          <Card variant="elevated" padding="lg">
            <div className="text-center py-8">
              {/* Warning Icon */}
              <div className="w-20 h-20 mx-auto mb-6 bg-amber-100 flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-amber-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-amber-700 mb-3">Payment Cancelled</h3>

              {/* Message */}
              <p className="text-neutral-600 max-w-md mx-auto mb-6">
                You cancelled the payment process. No charges have been made to
                your account.
              </p>

              {/* Info Box */}
              {shortCode && (
                <div className="inline-flex items-center gap-2 px-4 py-3 bg-amber-50 border border-amber-100 mb-6">
                  <svg
                    className="w-5 h-5 text-amber-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="text-sm text-amber-800">
                    Your payment link is still valid. You can return to complete
                    the payment at any time.
                  </span>
                </div>
              )}

              {/* Actions */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
                {shortCode && (
                  <Link to={`/p/${shortCode}`}>
                    <Button variant="copper" size="lg">
                      Return to Payment
                    </Button>
                  </Link>
                )}
                <a href="https://nestrentalapartments.com">
                  <Button variant="secondary" size="lg">
                    Go to NEST Website
                  </Button>
                </a>
              </div>
            </div>
          </Card>

          {/* Contact */}
          <div className="mt-6 text-center text-sm text-neutral-500">
            <p>
              Changed your mind about the reservation?{' '}
              <a
                href="mailto:reservas@nestrentalapartments.com"
                className="text-neutral-900 hover:underline"
              >
                Contact us
              </a>
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
